import { InventoryItemDisplay, SecurityClass } from '@bakerweb/models';
import { isNull } from 'lodash';
import { subtypeMap } from './subtypeMap';

// special case sub_type keys
const IE30 = /^IE30.*/;
const IE = /^IE.*/;
const IF = /^IF.*/;

// sub_type keys larger than 2 chars long
const LLSTRUCTURED = /^LLSTRUCTURED.*/;
const IGDUS = /^IGDUS.*/;

// sec_desc cases
const REPERFORM = /.*REPERFORM.*/;
const JUMBO = /.*Jumbo.*/;
const THIRTY_YR = /.*30YR.*/;
const FORTY_YR = /.*40YR.*/;

// sec class shortDesc case
const SBA = /^SBA$/;

export const convertSubType = (item: InventoryItemDisplay) => {
  const { SUB_TYPE, SEC_DESC, securityClass } = item;
  const { shortDesc } = securityClass as SecurityClass;

  if (!isNull(SUB_TYPE) && !isNull(SEC_DESC)) {
    const case30Yr = IE.test(SUB_TYPE) && THIRTY_YR.test(SEC_DESC) && !REPERFORM.test(SEC_DESC);
    const case30YrJumbo =
      (IE.test(SUB_TYPE) && THIRTY_YR.test(SEC_DESC) && JUMBO.test(SEC_DESC)) ||
      (IE30.test(SUB_TYPE) && JUMBO.test(SEC_DESC));
    const case30YrMod =
      (IE.test(SUB_TYPE) && THIRTY_YR.test(SEC_DESC) && REPERFORM.test(SEC_DESC)) ||
      (IE30.test(SUB_TYPE) && REPERFORM.test(SEC_DESC));

    if (case30Yr) return '30Yr';
    if (case30YrJumbo) return '30Yr Jumbo';
    if (case30YrMod) return '30Yr Mod';
    if (FORTY_YR.test(SEC_DESC)) return REPERFORM.test(SEC_DESC) ? '40yr Mod' : '40Yr';
    if (IF.test(SUB_TYPE)) return !isNull(shortDesc) && SBA.test(shortDesc) ? SUB_TYPE.slice(2) : '40yr';
    if (LLSTRUCTURED.test(SUB_TYPE)) return 'CMBS';
    if (IGDUS.test(SUB_TYPE)) return 'DUS';

    // Rest of the normal cases
    const subtypeKey = SUB_TYPE.slice(0, 2);
    if (subtypeMap.has(subtypeKey)) {
      return subtypeMap.get(subtypeKey);
    }
  }
  return SUB_TYPE;
};

export const convertYTW = (item: InventoryItemDisplay) => {
  const { YTW, YTC, YTM } = item;
  if (!isNull(YTW) && YTW > 0) {
    return YTW;
  }
  if (!isNull(YTC) && YTC > 0 && !isNull(YTM) && YTC < YTM) {
    return YTC;
  }
  return YTM;
};

export const convertSeason = (item: InventoryItemDisplay) => {
  const { WALA } = item;
  if (!isNull(WALA)) {
    if (WALA < 30) return 'N';
    if (WALA > 30 && WALA < 60) return 'M';
    return 'S';
  }
  return WALA; // null
};

export const convertRating = (item: InventoryItemDisplay) => (isNull(item.STDPOOR) ? item.MOODY : item.STDPOOR);
